var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditBlack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6806 6.86492L17.1351 0.319406C16.7091 -0.106469 16.0185 -0.106469 15.5925 0.319406L0.319639 15.5923C0.115038 15.7968 6.17869e-05 16.0743 0 16.3636V22.9091C0 23.5116 0.488421 24 1.09092 24H7.63644C7.92574 23.9999 8.20318 23.885 8.40772 23.6804L23.6806 8.40749C24.1065 7.98148 24.1065 7.29093 23.6806 6.86492ZM7.18484 21.8184H2.18188V16.8154L13.0911 5.90625L18.094 10.9092L7.18484 21.8184ZM14.6337 4.36399L19.6366 9.36694L21.3668 7.63674L16.3639 2.63379L14.6337 4.36399Z",
    fill: "#4A4A4A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editBlack.e9bd53705065a4e4756e81246862d83c.svg";